module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_3016.04fbb8fa.png";